import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'online-app-agent-set-password',
  templateUrl: './agent-set-password.component.html',
  styleUrls: ['./agent-set-password.component.scss']
})
export class AgentSetPasswordComponent implements OnInit {

  agentSetPasswordFormGroup: FormGroup;
  user: any;
  isFormSubmitted = false;

  constructor(private fb: FormBuilder,
              private store: Store<any>,
              private router: Router,
              private authService: AuthService,
              private titleService: Title) {
                this.titleService.setTitle("Online Application Portal - DE International - Agent");
              }

  ngOnInit() {


    this.agentSetPasswordFormGroup = this.fb.group({
      accountPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword:  ['', [Validators.required, Validators.minLength(8)]],
    });


    this.store.pipe(select('shared'))
    .subscribe( sharedState => {
      if (sharedState) {
        this.user = sharedState.agentUserObject;
      } else {
        this.user = null;
      }
    });

  }

  validatePasswords(): boolean {
    const accountPassword = this.agentSetPasswordFormGroup.get('accountPassword').value;
    const confirmPassword = this.agentSetPasswordFormGroup.get('confirmPassword').value;

    return accountPassword ===  confirmPassword;
  }

  setPassword() {

    this.isFormSubmitted = true;

    if (this.agentSetPasswordFormGroup.valid) {

      if (!this.validatePasswords()) {
        this.agentSetPasswordFormGroup.get('accountPassword').setErrors({passwordsDontMatch: true});
        this.agentSetPasswordFormGroup.updateValueAndValidity();
        return ;
      }

      const accountPassword = this.agentSetPasswordFormGroup.get('accountPassword').value;
      this.authService.completeNewPassword(this.user, accountPassword)
        .subscribe( (user) => {
          this.router.navigate(['/applications', 'agent-dashboard']);
        }, (err: any) => {
          //console.log('error happened while setting the new password');
          //console.log(err);
        });

    }
  }

  errorPasswordAccessibility(): string {
    if (this.isFormSubmitted &&
      this.agentSetPasswordFormGroup.get('accountPassword').errors &&
      this.agentSetPasswordFormGroup.get('accountPassword').errors.required) {
      return "requiredPassword";
    } else if (this.isFormSubmitted &&
      this.agentSetPasswordFormGroup.get('accountPassword').errors &&
      this.agentSetPasswordFormGroup.get('accountPassword').errors.minlength) {
      return "minlengthPassword";
    } else if (this.isFormSubmitted &&
      this.agentSetPasswordFormGroup.get('accountPassword').errors &&
      this.agentSetPasswordFormGroup.get('accountPassword').errors.passwordsDontMatch) {
      return "matchPassword";
    } else {
      return "";
    }
  }

  errorConfirmPasswordAccessibility(): string {
    if (this.isFormSubmitted &&
      this.agentSetPasswordFormGroup.get('confirmPassword').errors &&
      this.agentSetPasswordFormGroup.get('confirmPassword').errors.required) {
      return "reEnterConfirmPassword";
    } else if (this.isFormSubmitted &&
      this.agentSetPasswordFormGroup.get('confirmPassword').errors &&
      this.agentSetPasswordFormGroup.get('confirmPassword').errors.minlength) {
      return "minlengthConfirmPassword";
    } else {
      return "";
    }
  }
}
